import { provincias } from '@/utils/provincias.utils.js'
import { diasSemana } from '@/utils/dias.utils.js'
export default {
    negociosArray: [],
    impresorasNegocio: [],
    ordenadoresNegocio: [],
    clientesNegocio: [],
    provinciasSelect: provincias,
    diasSemana: diasSemana,
    modoHorarios: [
        {
            text: 'Automático',
            value: 'auto'
        },
        {
            text: 'Forzar el cierre',
            value: 'forzado_cierre'
        },
        {
            text: 'Cierre por el sistema',
            value: 'forzado_cierre_sistema'
        }
    ],
    pedidosArray: []
}